import type { CartItem, Ticket,UpsaleTicket } from "@/types";

import { formatDateWithOffset } from "./formatDate";

const DEFAULT_LANGUAGE = 'da';

type LocalizationKeys = keyof CartItem['localizations'][string];

export const getLocalizedCartItemValue = (
  cartItem: CartItem,
  language: string = DEFAULT_LANGUAGE,
  key: LocalizationKeys,
  characterLimit: number = 0
): string => {    
  let value = cartItem.localizations?.[language]?.[key] || Object.values(cartItem.localizations || {}).find(localization => localization[key])?.[key] || '';
  if( characterLimit > 0  && value.length > characterLimit ) {
    value = value.slice(0, characterLimit) + '...';
  }
  return value;
};

export const getDisplayDate = (
  cartItem: CartItem,
  locale: string = DEFAULT_LANGUAGE,
): string => {
  if (cartItem.eventtime_override) {
    return cartItem.eventtime_override;
  }
  return formatDateWithOffset(cartItem.eventtime, cartItem.eventtime_gmt_offset, { locale, showTime: true });

};

export const getTickets = (
  cartItem: CartItem,
): Ticket[] => {
   return cartItem.tickets.filter(ticket => !ticket.upsale_flag);
}

export const getUpsaleTickets = (
  cartItem: CartItem,
): UpsaleTicket[] => {
   return cartItem.tickets.filter(ticket => ticket.upsale_flag);
}
